(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-99k"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('home99k-stories')) {
  customElements.define('home99k-stories', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-stories-track]');
      if (!this.track) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = this.querySelector('.home99k__motion');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reducedMotion.matches;
      this.updateMotionLabel();
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => this.advance(Number(button.dataset.direction)), options);
      });
      this.motion.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateMotionLabel();
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.advance(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.addEventListener('pointerenter', () => { this.hovering = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovering = false; }, options);
      this.addEventListener('pointerdown', () => { this.lastInteraction = Date.now(); }, options);
      this.reducedMotion.addEventListener('change', () => {
        this.paused = this.reducedMotion.matches;
        this.updateMotionLabel();
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.classList.toggle('home99k__slider--static', !hasOverflow);
        this.querySelectorAll('button').forEach(button => { button.hidden = !hasOverflow; });
      });
      this.resizeObserver.observe(this.track);
      this.timer = window.setInterval(() => {
        if (document.hidden || this.paused || this.hovering || this.matches(':focus-within')) return;
        if (Date.now() - (this.lastInteraction || 0) < 3000) return;
        const bounds = this.getBoundingClientRect();
        if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
        this.advance(1);
      }, 3000);
    }
    updateMotionLabel() {
      this.motion.textContent = this.paused ? 'Continuar' : 'Pausar';
      this.motion.setAttribute('aria-pressed', String(this.paused));
      this.motion.setAttribute('aria-label', this.paused ? 'Continuar avanço automático' : 'Pausar avanço automático');
    }
    advance(direction) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 2) return;
      const first = this.track.querySelector('.home99k__item');
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      const position = this.track.scrollLeft;
      const next = direction > 0
        ? (position >= max - 2 ? 0 : Math.min(max, position + step))
        : (position <= 2 ? max : Math.max(0, position - step));
      this.track.scrollTo({ left: next, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      window.clearInterval(this.timer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrine-99k"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vit-99k')){customElements.define('vit-99k',class extends HTMLElement{connectedCallback(){var t=this.querySelector('[data-vit99k-track]');if(!t)return;var p=this.querySelector('.vit99k__seta--prev'),n=this.querySelector('.vit99k__seta--next');var rtl=getComputedStyle(t).direction==='rtl';var up=function(){var max=t.scrollWidth-t.clientWidth;var pos=Math.abs(t.scrollLeft);p.hidden=pos<=4;n.hidden=pos>=max-4;};this.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){var it=t.querySelector('.vit99k__item');var gap=parseFloat(getComputedStyle(t).columnGap)||0;var step=it?it.getBoundingClientRect().width+gap:300;t.scrollBy({left:step*Number(b.dataset.dir)*(rtl?-1:1),behavior:'smooth'});});});t.addEventListener('scroll',up,{passive:true});window.addEventListener('resize',up);up();}});}
  } catch(e) { console.error(e); }
})();
})();
